export const fichasTecnicasInitialState = {
  fichasTecnicas: [],
  fichaTecnicaApagada: {},
  fichaTecnicaAdicionada: {},
  lastFichasTecnicas: [],
};
